'use strict';

angular.module('client.services').factory('classSyncService', ['$resource', '$q', '$log', 'api_server',
  function ($resource, $q, $log, api_server) {
    const availabilityResource = $resource(api_server + '/classes/:cid/sync-availability',
      { cid: '@cid' },
      { get: { method: 'GET' } });

    const syncResource = $resource(api_server + '/classes/:cid/sync',
      { cid: '@cid' },
      { post: { method: 'POST' } });
    let availabilityCache = {};

    function normalizeAvailabilityError(error) {
      const data = error && error.data ? error.data : {};
      return {
        classId: data.classId || null,
        integrationId: data.integrationId || null,
        provider: data.provider || null,
        canSync: false,
        reason: data.reason || (error && error.status === 403 ? 'accessUnavailable' : 'error'),
        message: data.message || null,
        tenantId: data.tenantId || null,
        classSourcedId: data.classSourcedId || null,
        externalStatus: data.externalStatus || null,
        checkedAt: data.checkedAt || null,
        details: data.details || null
      };
    }

    function getAvailability(classId, options) {
      if (!classId) {
        return $q.when({
          classId: null,
          canSync: false,
          reason: 'classNotFound',
          message: 'This class could not be found.'
        });
      }

      const cacheKey = String(classId);
      const useCache = !options || options.refresh !== true;
      if (useCache && availabilityCache[cacheKey]) {
        return availabilityCache[cacheKey];
      }

      const request = availabilityResource.get({ cid: classId }).$promise
        .then(function(availability) {
          availabilityCache[cacheKey] = $q.when(availability);
          return availability;
        })
        .catch(function(error) {
          delete availabilityCache[cacheKey];
          $log.warn('Class sync availability check failed:', error);
          return normalizeAvailabilityError(error);
        });
      availabilityCache[cacheKey] = request;
      return request;
    }

    function syncClass(classId) {
      return syncResource.post({ cid: classId }, {}).$promise;
    }

    return {
      getAvailability: getAvailability,
      syncClass: syncClass,
      normalizeAvailabilityError: normalizeAvailabilityError
    };
  }]);
